<ul class="nav nav-tabs">
    <li class="nav-item">
        <a class="nav-link" routerLink="/recipe/default" routerLinkActive="active">User Default Recipes (Mine tab on mobile)</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" routerLink="/recipe/machine-default" routerLinkActive="active">Machine Default recipes</a>
    </li>
</ul>